import { CurrencyValue, HugValue, NumberValue, PercentageValue } from '@/components/tableElements';
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import { mapState } from "vuex";
export default {
  name: "ProductTableTotal",
  mixins: [LiteTableMixin],
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    total: {
      type: Object,
      default: () => ({})
    },
    currencyConfig: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CurrencyValue,
    HugValue,
    NumberValue,
    PercentageValue,
    EvolutionValue,
    SlotWithEvolutionValue
  },
  computed: {
    ...mapState({
      periodCategory: state => state.ppc_v2.periodCategory
    })
  },
  methods: {
    isTotalColumn(field) {
      return ['seller_name', 'sales_channel', 'campaign_group_name', 'campaign_name', 'targeting', 'product_name'].includes(field.key);
    }
  }
};